import { z } from "zod";
import { IS_PRF_TEMPLATE } from "~/utils/constants";

const errorMessage = IS_PRF_TEMPLATE
  ? "O CPF é obrigatório"
  : "A matrícula é obrigatória";

export const sendTokenValidationSchema = z.object({
  email: z.string({ required_error: errorMessage }).min(1, errorMessage),
  password: z
    .string({ required_error: "A senha é obrigatória" })
    .min(1, "A senha é obrigatória"),
});

export type SendTokenFormInput = z.input<typeof sendTokenValidationSchema>;

export const externalSendTokenValidationSchema = z.object({
  email: z
    .string({ required_error: "O e-mail é obrigatório" })
    .min(1, "O e-mail é obrigatório")
    .email("E-mail inválido"),
  password: z
    .string({ required_error: "A senha é obrigatória" })
    .min(1, "A senha é obrigatória"),
});

export type ExternalSendTokenFormInput = z.input<
  typeof externalSendTokenValidationSchema
>;

export const loginValidationSchema = z.object({
  token: z
    .string({ required_error: "O token é obrigatório" })
    .min(1, "O token é obrigatório"),
});

export type LoginFormInput = z.input<typeof loginValidationSchema>;
